import React from 'react';
import { Form, Card, Button, Spinner } from 'react-bootstrap';
import { useUploadFile } from '../../../../../api/fileUpload/fileUpload.hooks';

const ServicesEditor = ({ servicesSection, onChange }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onChange({ ...servicesSection, [field]: value });
  };

  const handleServiceChange = (index, field, value) => {
    const newServices = [...servicesSection.services];
    newServices[index] = { ...newServices[index], [field]: value };
    onChange({ ...servicesSection, services: newServices });
  };

  const handleServiceImageUpload = async (index, e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const result = await upload(file);
      handleServiceChange(index, 'image', result.url);
    } catch (err) {
      console.error('Upload failed:', err);
    }
  };

  const addService = () => {
    onChange({
      ...servicesSection,
      services: [...servicesSection.services, { title: '', description: '', image: '' }]
    });
  };

  const removeService = (index) => {
    const newServices = servicesSection.services.filter((_, i) => i !== index);
    onChange({ ...servicesSection, services: newServices });
  };

  return (
    <Card className="mb-3">
      <Card.Header className='bg-neutral-gray'>
        <h5 className="mb-0">Why Choose Us</h5>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>Heading</Form.Label>
          <Form.Control
            type="text"
            value={servicesSection.heading}
            onChange={(e) => handleChange('heading', e.target.value)}
          />
        </Form.Group>

        <div>
          <h6 className="mb-3">Services</h6>
          {servicesSection.services.map((service, index) => (
            <div key={index} className="mb-3 p-3 border rounded">
              <Form.Group className="mb-2">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  value={service.title}
                  onChange={(e) => handleServiceChange(index, 'title', e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  value={service.description}
                  onChange={(e) => handleServiceChange(index, 'description', e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label>Image</Form.Label>
                <div>
                  {service.image ? (
                    <div className="position-relative d-inline-block">
                      <img
                        src={service.image}
                        alt={service.title}
                        style={{ width: '200px', height: '150px', objectFit: 'cover', borderRadius: '4px' }}
                      />
                      <Button
                        variant="danger"
                        size="sm"
                        className="position-absolute top-0 end-0"
                        style={{ transform: 'translate(50%, -50%)' }}
                        onClick={() => handleServiceChange(index, 'image', '')}
                      >
                        <i className="fa fa-times"></i>
                      </Button>
                    </div>
                  ) : (
                    <Button
                      variant="outline-primary"
                      as="label"
                      disabled={isUploading}
                    >
                      {isUploading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-1" />
                          Uploading...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-upload me-1"></i> Upload Image
                        </>
                      )}
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={(e) => handleServiceImageUpload(index, e)}
                      />
                    </Button>
                  )}
                </div>
              </Form.Group>

              <Button variant="danger" size="sm" onClick={() => removeService(index)}>
                <i className="fa fa-trash me-1"></i> Remove Service
              </Button>
            </div>
          ))}
          <Button variant="outline-primary" size="sm" onClick={addService}>
            <i className="fa fa-plus me-1"></i> Add Service
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ServicesEditor;
